/** Серия дней: окно и карточка десктопа — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { StreakCardView, StreakView } from "./view";
import { appStore, useStore, registerWindow } from "../../../app";
import { actions } from "../actions";
import { balanceV1 } from "@newfungame/engine";
import { streakDays } from "./model";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    streak: object;
  }
}

export function Streak({ close }: WindowProps<"streak">) {
  const streak = useStore(appStore, (s) => s.player?.streak ?? null);
  if (!streak) return null;
  return (
    <StreakView
      day={streak.day}
      days={streakDays(balanceV1, streak)}
      claimable={!streak.claimedToday}
      onClaim={() => {
        actions().claimStreak();
        close();
      }}
      onClose={close}
    />
  );
}

/** Серия карточкой для правой колонки десктопа (C6): те же данные и «Забрать», но не окно — закрывать нечего. */
export function StreakCard() {
  const streak = useStore(appStore, (s) => s.player?.streak ?? null);
  if (!streak) return null;
  return (
    <StreakCardView
      day={streak.day}
      days={streakDays(balanceV1, streak)}
      claimable={!streak.claimedToday}
      onClaim={() => actions().claimStreak()}
    />
  );
}

export function register(): void {
  registerWindow("streak", Streak);
}
